import { useState, useEffect, useContext } from "react"
import { useParams, useHistory, useLocation } from "react-router-dom";
import { Card, CardBody, CardHeader, CardTitle, CardText, ListGroup, ListGroupItem, Row, Col, Button, Input, Label } from "reactstrap";
import PanelHeader from "components/PanelHeader/PanelHeader";
import PhoneNumberService from "core/api/PhoneNumberService";
import { CrudDropdownEditDelete } from "views/Shared/CrudDropdownEditDelete";


const View = () => {
    const { id } = useParams();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const history = useHistory();


    useEffect(() => {
        async function fetchData() {
            const phoneNumber = await PhoneNumberService.get(id);

            setData(phoneNumber);

            setLoading(false);
        }
        fetchData();
    }, [])

    if (loading) return <>Loading</>;
    return (
        <>
            <PanelHeader
                content={
                    <div className="header text-center">
                        <h1 className="title">
                            Phone Number
                        </h1>
                        <h2 className="title">
                            {data?.phoneNumber}
                        </h2>
                    </div>
                }
            />
            <div className="content">
                <Row>
                    <Col xs={12} md={12}>
                        <Card>
                            <CardHeader className="d-flex justify-content-between align-items-center">
                                <CardTitle tag="h4">Phone Number Information</CardTitle>
                                <Col xs="auto">
                                    <CrudDropdownEditDelete
                                        id={id}
                                        onDelete={() => {
                                            PhoneNumberService.delete(id);
                                            history.goBack();
                                        }}
                                        deletePermissions={["all:phone_numbers", "delete:phone_numbers", "admin"]}
                                        editPermissions={["all:phone_numbers", "write:phone_numbers", "admin"]}
                                    />
                                </Col>
                            </CardHeader>
                            <CardBody>
                                <ListGroup >
                                    <ListGroupItem>
                                        <strong>Name:</strong> {data?.name}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Phone Number:</strong> {data?.phoneNumber}
                                    </ListGroupItem>

                                    <ListGroupItem>
                                        <strong>Notes:</strong> {data?.notes}
                                    </ListGroupItem>

                                </ListGroup>
                            </CardBody>
                        </Card>

                    </Col>
                </Row>
            </div >

        </>
    )
}

export default View